import {NgModule} from "@angular/core";
import {SuiModule} from "ng2-semantic-ui";
import {PitPageHeaderComponent} from "./ui/components/pit-page-header/pit-page-header.component";
import {PitPageFooterComponent} from "./ui/components/pit-page-footer/pit-page-footer.component";
import {DxAuthModule} from "../dx-auth/dx-auth.module";
import {PitErrorPageComponent} from "./ui/components/pit-error-page/pit-error-page.component";
import {PitLoginPageComponent} from "./ui/components/pit-login-page/pit-login-page.component";
import {CommonModule} from "@angular/common";
import {DxPageMarkupModule} from "../dx-page-markup/dx-page-markup.module";
import { PitWelcomePageComponent } from './ui/components/pit-welcome-page/pit-welcome-page.component';
import { PitSettingsModalComponent } from './ui/components/pit-settings-modal/pit-settings-modal.component';
import {DxFormsModule} from "../dx-forms/dx-forms.module";
import { PitDashboardFilesComponent } from './ui/components/pit-dashboard-files/pit-dashboard-files.component';
import {DxGridModule} from "../dx-grid/dx-grid.module";
import {PitFileUploadModalComponent} from "./ui/components/file-upload-modal/pit-file-upload-modal.component";
import {PitResponsibleUsersComponent} from "./ui/components/responsible-users/pit-responsible-users.component";
import {PitControlPointsComponent} from "./ui/components/pit-control-points/pit-control-points.component";
import { PitFilesComponent } from './ui/components/pit-files/pit-files.component';


/**
 * Модуль для system-wide комопнентов. Который импортируется множество раз в разных lazy и не только модулях
 * TODO: в последствии можно поделить на два модуля. Потому как многие компоненты в нём противоречат названию common и используются только один раз в AppModule
 */
@NgModule({
  declarations: [
    PitPageHeaderComponent,
    PitPageFooterComponent,
    PitLoginPageComponent,
    PitErrorPageComponent,
    PitWelcomePageComponent,
    PitSettingsModalComponent,
    PitDashboardFilesComponent,
    PitFilesComponent,
    PitFileUploadModalComponent,
    PitResponsibleUsersComponent,
    PitControlPointsComponent,
  ],
  entryComponents: [
    PitSettingsModalComponent,
    PitFilesComponent,
    PitFileUploadModalComponent,
    PitResponsibleUsersComponent,
    PitControlPointsComponent
  ],
  exports: [
    PitPageHeaderComponent,
    PitPageFooterComponent,
    PitLoginPageComponent,
    PitErrorPageComponent,
    PitDashboardFilesComponent,
    PitFilesComponent,
    PitFileUploadModalComponent,
    PitResponsibleUsersComponent,
    PitControlPointsComponent
  ],
  imports: [
    CommonModule,
    DxPageMarkupModule,
    DxFormsModule,
    DxAuthModule,
    DxGridModule,
    SuiModule
  ],
  bootstrap: []
})
export class PitCommonModule { }
